import dayjs from 'dayjs';

import type { ClosingPeriodType } from 'app/typings/core/admin/experiences/closingPeriod/closingPeriod';
import type { ExtranetHotelExperience } from 'app/typings/core/extranet/hotel/experiences';

import { getStatusInfoByMessage } from '../../../../../_components/TabViews/inventoryStatusUtils';
import type { StatusInfo } from '../../../../../_components/TabViews/inventoryStatusUtils';

import { isDayClosedByOpeningHours } from './openingHours';

const isWithinClosingPeriod = (
  closingPeriods: ClosingPeriodType[] | undefined,
  date: Date
): boolean => {
  const day = dayjs(date).startOf('day');

  return (closingPeriods ?? []).some((period) => {
    const start = dayjs(period.start).startOf('day');
    const end = dayjs(period.end).startOf('day');

    return !day.isBefore(start) && !day.isAfter(end);
  });
};

const isWithinLastMinuteWindow = (
  closedDaysBeforeCheckIn: number | undefined,
  date: Date
): boolean => {
  if (closedDaysBeforeCheckIn === undefined) {
    return false;
  }

  const limit = dayjs().startOf('day').add(closedDaysBeforeCheckIn, 'day');

  return !dayjs(date).startOf('day').isAfter(limit);
};

export const getDayStatus = (
  experience: ExtranetHotelExperience | undefined,
  date: Date,
  saleEndDate?: Date
): StatusInfo | null => {
  const day = dayjs(date).startOf('day');

  if (day.isBefore(dayjs().startOf('day'))) {
    return getStatusInfoByMessage('PAST_SALES');
  }

  if (saleEndDate && day.isAfter(dayjs(saleEndDate).startOf('day'))) {
    return getStatusInfoByMessage('FUTURE_SALES');
  }

  if (!experience) {
    return null;
  }

  if (isWithinClosingPeriod(experience.closingPeriods, date)) {
    return getStatusInfoByMessage('CLOSING_PERIOD');
  }

  if (isWithinLastMinuteWindow(experience.closedDaysBeforeCheckIn, date)) {
    return getStatusInfoByMessage('CLOSED_BEFORE_CHECKIN');
  }

  if (isDayClosedByOpeningHours(experience.openingHours, date)) {
    return getStatusInfoByMessage('STOCK_CLOSED');
  }

  return null;
};
